import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import Hero from '../components/Hero';
import CategoryFilter from '../components/CategoryFilter';
import AssetGrid from '../components/AssetGrid';
import Footer from '../components/Footer';
import './HomePage.css';

function HomePage() {
  const [searchParams] = useSearchParams();
  const [assets, setAssets] = useState([]);
  const [filteredAssets, setFilteredAssets] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const categoryFromUrl = searchParams.get('category');
    if (categoryFromUrl) {
      setSelectedCategory(categoryFromUrl);
    }
  }, [searchParams]);

  useEffect(() => {
    fetchAssets();
  }, []);

  useEffect(() => {
    filterAssets();
  }, [selectedCategory, searchQuery, assets]);

  const fetchAssets = async () => {
    try {
      const response = await axios.get('/api/assets');
      setAssets(response.data);
      setFilteredAssets(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching assets:', error);
      setLoading(false);
    }
  };

  const filterAssets = () => {
    let filtered = [...assets];

    if (selectedCategory !== 'all') {
      filtered = filtered.filter(asset => asset.category === selectedCategory);
    }

    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(asset => {
        const titleMatch = asset.title?.toLowerCase().includes(query) || false;
        const tagsMatch = Array.isArray(asset.tags) && asset.tags.some(tag => 
          tag?.toLowerCase().includes(query)
        );
        return titleMatch || tagsMatch;
      });
    }

    setFilteredAssets(filtered);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  return (
    <div className="home-page">
      <Header />
      <Hero onSearch={handleSearch} />
      <div className="content-wrapper">
        <CategoryFilter
          selectedCategory={selectedCategory}
          onCategoryChange={handleCategoryChange}
        />
        <AssetGrid assets={filteredAssets} loading={loading} />
      </div>
      <Footer />
    </div>
  );
}

export default HomePage;
